import type { AvatarArt } from '@pixelworld/game-core/client';
import type { Avatar } from '@pixelworld/shared';
import { useEffect, useRef } from 'react';
import styles from './AvatarCanvas.module.css';

interface AvatarCanvasProps {
  art: AvatarArt;
  avatar: Avatar;
  /** In CSS pixels; the figure is drawn as large as fits, sharp on high-density screens. */
  width: number;
  height: number;
  label?: string;
}

/** A figure drawn by the game's own art, standing on the bottom edge. */
export function AvatarCanvas({ art, avatar, width, height, label }: AvatarCanvasProps) {
  const canvas = useRef<HTMLCanvasElement>(null);
  const density = Math.min(3, Math.max(1, Math.round(window.devicePixelRatio || 1)));
  useEffect(() => {
    if (canvas.current) void art.draw(canvas.current, avatar).catch(() => undefined);
  }, [art, avatar]);
  return (
    <canvas
      ref={canvas}
      className={styles.canvas}
      width={width * density}
      height={height * density}
      style={{ width, height }}
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    />
  );
}
